import { render, staticRenderFns } from "./MasiveNotifications.vue?vue&type=template&id=0cd54e23&scoped=true&"
import script from "./MasiveNotifications.vue?vue&type=script&lang=js&"
export * from "./MasiveNotifications.vue?vue&type=script&lang=js&"
import style0 from "./MasiveNotifications.vue?vue&type=style&index=0&id=0cd54e23&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0cd54e23",
  null
  
)

export default component.exports